// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1yHWk","obliqueLineWrap":"membershipbadge_obliqueLineWrap__23MEp","obliqueLine":"membershipbadge_obliqueLine__CuAFV"};